module.exports = __webpack_public_path__ + "img/filteruparw.6e829ce1.svg";